"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBaseApp = exports.BaseApp = void 0;
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const ObservableEntity_1 = require("./ObservableEntity");
class BaseApp extends ObservableEntity_1.ObservableEntity {
}
exports.BaseApp = BaseApp;
function makeBaseApp() {
    return new BaseAppImp();
}
exports.makeBaseApp = makeBaseApp;
class BaseAppImp extends BaseApp {
    constructor() {
        super(...arguments);
        this.startRendering = (container) => {
            throw new Error("[Base App] Start rendering function has not been injected");
        };
        this.stopRendering = () => {
            throw new Error("[Base App] Stop rendering function has not been injected");
        };
        this.memoizedIsAuthoring = new MemoizedBoolean_1.MemoizedBoolean(false, this.notify);
    }
    get isAuthoring() {
        return this.memoizedIsAuthoring.val;
    }
    set isAuthoring(val) {
        this.memoizedIsAuthoring.val = val;
    }
}
